/**
 * Business logic helpers for Blog Advisor Card functionality
 * These pure functions can be easily tested and reused
 */

/**
 * Constructs the advisor profile URL
 * @param {string} locale - Current locale (en/tc)
 * @param {string} baseUrl - Base URL from environment
 * @param {number} advisorId - Advisor ID
 * @returns {string} Complete profile URL
 */
export const buildAdvisorProfileUrl = (locale, baseUrl, advisorId) => {
  const language = locale === "en" ? "en" : "tc";
  return `${baseUrl}/${language}/find-advisor/advisor/${advisorId}`;
};

/**
 * Builds WhatsApp message with dynamic replacements
 * @param {string} template - Message template with placeholders
 * @param {Object} replacements - Object with replacement values
 * @returns {string} Processed message
 */
export const buildWhatsappMessage = (template, replacements) => {
  let message = template || '';
  
  const { advisorName, blogUrl, firstBlogCategory } = replacements;
  
  return message
    .replace('{advisor_name}', advisorName)
    .replace('{blog_url}', blogUrl)
    .replace('{first_blog_category_display_name}', firstBlogCategory);
};

/**
 * Constructs WhatsApp URL with encoded message
 * @param {string} phoneNumber - Phone number (without country code)
 * @param {string} message - Message to encode
 * @returns {string} Complete WhatsApp URL
 */
export const buildWhatsappUrl = (phoneNumber, message) => {
  const baseUrl = `https://api.whatsapp.com/send/?phone=852${phoneNumber}&text=`;
  return baseUrl + encodeURIComponent(message);
};

/**
 * Extracts current blog URL without query parameters
 * @returns {string} Clean blog URL
 */
export const getCurrentBlogUrl = () => {
  return location.toString().split('?')[0];
};

/**
 * Extracts the first blog tag from DOM
 * @returns {string} First blog tag text or empty string
 */
export const extractFirstBlogTag = () => {
  const tag = document.querySelector('.blog-single .tags .tag');
  return tag?.innerText || '';
};
